var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifyMeBellFilled16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57464_138369)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99701 1.59904C9.00021 1.56646 9.00185 1.53342 9.00185 1.5C9.00185 0.947715 8.55414 0.5 8.00185 0.5C7.44957 0.5 7.00185 0.947715 7.00185 1.5C7.00185 1.53342 7.00349 1.56646 7.0067 1.59904C4.72204 2.06044 3.00185 4.07933 3.00185 6.5V8.42893C3.00185 9.75501 2.47507 11.0268 1.53739 11.9645L0.70896 12.7929C0.0789954 13.4229 0.525163 14.5 1.41607 14.5L6.00185 14.5C6.00185 15.6046 6.89728 16.5 8.00185 16.5C9.10642 16.5 10.0019 15.6046 10.0019 14.5L14.5876 14.5C15.4785 14.5 15.9247 13.4229 15.2947 12.7929L14.4663 11.9645C13.5286 11.0268 13.0019 9.75501 13.0019 8.42893V6.5C13.0019 4.07933 11.2817 2.06043 8.99701 1.59904Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57464_138369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyMeBellFilled16);
export default __webpack_public_path__ + "static/media/notifyMeBellFilled-16.f00990b1.svg";
export { ForwardRef as ReactComponent };